module.exports = __webpack_public_path__ + "img/bg.01127050.png";